import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { BookingBar, ParkingFaq, ParkingNavigation, ParkingHeader, PageMetadata } from '../components/ParkingContent';
import { ParkingPriceExamples } from '../components/ParkingPriceExamples';

export default function ParkingInfoPage({ page }) {
  useEffect(() => { window.scrollTo(0, 0); }, [page.slug]);
  return <div className="parking-information" lang="es" data-testid={`parking-page-${page.slug}`}>
    <PageMetadata title={page.title} description={page.description} path={`/${page.slug}`} />
    <ParkingHeader />
    <main>
      <section className="parking-content-section parking-information-intro">
        <p className="parking-eyebrow">Valet · Aeropuerto Madrid-Barajas</p>
        <h1 data-testid="parking-page-heading">{page.heading}</h1>
        <p data-testid="parking-page-intro">{page.intro}</p>
        <Link to="/reservar" className="parking-reserve" data-testid="parking-page-reserve">Ver precio y reservar <ArrowRight size={18} aria-hidden="true" /></Link>
        <p className="parking-small">Selecciona tus fechas y consulta el importe completo antes de confirmar.</p>
      </section>
      {page.sections.map((section, index) => <section className="parking-content-section" key={section.title} data-testid={`parking-page-section-${index + 1}`}>
        <h2>{section.title}</h2><p>{section.text}</p>
      </section>)}
      {['tarifas', 'parking-larga-estancia-barajas'].includes(page.slug) && <ParkingPriceExamples />}
      <ParkingFaq /><ParkingNavigation currentSlug={page.slug} />
    </main>
    <footer className="parking-content-section parking-information-footer">
      <Link to="/terminos" data-testid="parking-footer-terms">Términos y condiciones</Link>
      <Link to="/privacidad" data-testid="parking-footer-privacy">Privacidad</Link>
      <a href="mailto:julioviv@pleyadesparking.es" data-testid="parking-footer-contact">Contacto</a>
    </footer>
    <BookingBar />
  </div>;
}